module.exports = __webpack_public_path__ + "static/media/Recomposition_01@2x.f8fdf284.png";